import React, { useContext, useEffect, useState } from "react";
import { BsChatDots } from "react-icons/bs";
import { LuHistory } from "react-icons/lu";
import { FaArrowLeftLong } from "react-icons/fa6";
import { LiaEdit } from "react-icons/lia";
import { MotionConfig, motion } from "framer-motion";
import logoWhite from "../../images/logoWhite.png";
import jooLogo from "../../images/joominLogo.png";
import jooIcon from "../../images/iconMobile.png";
import robot from "../../images/robot.png";
import { useNavigate } from "react-router-dom";
import { IoMdClose } from "react-icons/io";
import { getChatHistoryList } from "../../api/chatApi";
import { logout } from "../../api/authApi";
import { clearSession, clearSessionId, saveSessionId } from "../../utils/storage";
import AuthContext from "../../context/AuthContext";

function Sidebar() {
  return (
    <div className="h-full">
      <SidebarContent />
    </div>
  );
}

export default Sidebar;

const SidebarContent = () => {
  const [open, setOpen] = useState(true);
  const [selected, setSelected] = useState("History");
  const [historyDivs, setHistoryDivs] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { dispatch } = useContext(AuthContext);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const navigate = useNavigate();
  const handleLogout = async () => {
    try {
      await logout();
      dispatch({ type: "LOGOUT" });
      clearSession();
      clearSessionId();
      navigate("/login");

    } catch (error) {
      console.error("Logout failed:", error);
    }

  };

  const handleNewChat = () => {
    navigate("/");
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await getChatHistoryList();
        setHistoryDivs(response.data);
      } catch (error) {
        console.error("Failed to fetch chat history:", error);
      }
    }

    fetchData();
  }, []);
  const handleHistoryItemClick = (sessionId) => {
    saveSessionId(sessionId);
    setIsModalOpen(false);
    navigate(`/history/${sessionId}`);
    window.location.reload();
  };

  return (
    <motion.nav
      className={`sticky h-full top-0 shrink-0  bg-darkPurple p-2 flex flex-col justify-between ${open ? " sidebarContentClosed" : "sidebarContent"
        }`}
      initial={false}
      animate={{
        width: open ? "225px" : "85px",
      }}
      transition={{
        duration: 0.5,
      }}
    >
      <div className="h-full">
        <ToggleClose open={open} setOpen={setOpen} />
        <div className="space-y-2 ">
          <div className="flex justify-center mt-4">
            {open ? (
              <img className="w-58" src={jooLogo} alt="joomin Logo" />
            ) : (
              <img className="w-10" src={jooIcon} alt="joomin Logo" />
            )}
          </div>
          <Option
            Icon={BsChatDots}
            title="New Chat"
            selected={selected}
            setSelected={setSelected}
            open={open}
            onClick={handleNewChat}
          />

          <Option
            Icon={LuHistory}
            title="History"
            selected={selected}
            setSelected={setSelected}
            open={open}
            onClick={toggleModal}
          />

          {isModalOpen && (
            <div
              className="fixed inset-0  overflow-auto z-50 bg-black/70 rounded-lg h-full"
              style={{ margin: "0" }}
            >
              <div className="relative flex items-start justify-center ">
                <div className="bg-darkPurple p-4 rounded-lg w-1/2 mb-2">
                  <h1 className="text-center text-white text-4xl font-bold my-4">
                    History Chats
                  </h1>
                  <div className="grid grid-cols-1 gap-4">
                    {historyDivs.map((item) => (
                      <div
                        key={item.session_id}
                        className="flex justify-between items-center border border-lightPurple text-white py-2 px-6 mx-4 rounded-xl cursor-pointer "
                        onClick={() => handleHistoryItemClick(item.session_id)}
                      >
                        <h6>{item.message}</h6>
                        <span className="text-2xl mb-1">
                          <LiaEdit />
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
                <button
                  className="absolute top-4 right-4 p-1 text-3xl bg-red-500 text-white rounded-lg"
                  onClick={toggleModal}
                >
                  <IoMdClose />
                </button>
              </div>
            </div>
          )}

          {/* {historyDivs.slice(0, 3).map((item) => (
            <div
              key={item.session_id}
              onClick={() => handleHistoryItemClick(item.session_id)}
              className={`flex justify-around items-center border border-lightPurple text-white py-2 mx-4 rounded-xl cursor-pointer ${
                open ? "block" : "hidden"
              }`}
            >
              <h6>{item.message.slice(0, 12)}...</h6>
              <span className="text-2xl mb-1">
                <LiaEdit />
              </span>
            </div>
          ))} */}
        </div>
      </div>
      <div className="space-y-4 mb-6">
        <Option
          Icon={FaArrowLeftLong}
          title="Logout"
          selected={selected}
          setSelected={setSelected}
          open={open}
          onClick={handleLogout}
        />

        <div className="flex justify-center">
          <img src={logoWhite} alt="logo" />
        </div>
      </div>

      <div className={`flex justify-center mt-4 ${open ? "block" : "hidden"}`}>
        <img className="w-4/5 robotImage" src={robot} alt="logo" />
      </div>
    </motion.nav>
  );
};

const Option = ({ Icon, title, setSelected, open, onClick }) => {
  return (
    <motion.button
      // onClick={() => setSelected(title)}
      onClick={() => {
        setSelected(title);
        if (onClick) onClick();
      }}
      className="relative flex h-20 w-full flex-col items-center justify-center rounded-md transition-colors text-white hover:bg-purpleColorLight gap-2"
    >
      <motion.div className="flex items-center justify-center text-lg">
        <Icon style={{ fontSize: "28px" }} />
      </motion.div>
      {open && (
        <motion.span
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.125 }}
          className="text-lg font-medium"
        >
          {title}
        </motion.span>
      )}
    </motion.button>
  );
};

const ToggleClose = ({ open, setOpen }) => {
  return (
    <div className="flex justify-center">
      <MotionConfig
        transition={{
          duration: 0.5,
          ease: "easeInOut",
        }}
      >
        <motion.button
          initial={false}
          animate={open ? "open" : "closed"}
          onClick={() => setOpen((pv) => !pv)}
          className="relative h-14 w-14 transition-colors my-3 "
        >
          <motion.span
            variants={VARIANTS.top}
            className="absolute h-1 w-10 bg-white"
            style={{ y: "-50%", left: "50%", x: "-50%", top: "35%" }}
          />
          <motion.span
            variants={VARIANTS.middle}
            className="absolute h-1 w-10 bg-white"
            style={{ left: "50%", x: "-50%", top: "50%", y: "-50%" }}
          />
          <motion.span
            variants={VARIANTS.bottom}
            className="absolute h-1 w-5 bg-white"
            style={{
              x: "-50%",
              y: "50%",
              bottom: "35%",
              left: "calc(50% + 10px)",
            }}
          />
        </motion.button>
      </MotionConfig>
    </div>
  );
};

const VARIANTS = {
  top: {
    open: {
      rotate: ["0deg", "0deg", "45deg"],
      top: ["35%", "50%", "50%"],
    },
    closed: {
      rotate: ["45deg", "0deg", "0deg"],
      top: ["50%", "50%", "35%"],
    },
  },
  middle: {
    open: {
      rotate: ["0deg", "0deg", "-45deg"],
    },
    closed: {
      rotate: ["-45deg", "0deg", "0deg"],
    },
  },
  bottom: {
    open: {
      rotate: ["0deg", "0deg", "45deg"],
      bottom: ["35%", "50%", "50%"],
      left: "50%",
    },
    closed: {
      rotate: ["45deg", "0deg", "0deg"],
      bottom: ["50%", "50%", "35%"],
      left: "calc(50% + 10px)",
    },
  },
};
